import { useVisitorInfoStore } from '@systemeio/digital-store-shared';
import { useEffect, useRef } from 'react';
import { httpClient } from '../api/http-client';
export function VisitorInfoProvider({ children }) {
    const { setVisitorInfo } = useVisitorInfoStore();
    const visitorInfoRef = useRef(false);
    useEffect(() => {
        if (visitorInfoRef.current)
            return;
        const getVisitorInfo = async () => {
            try {
                const responseData = await httpClient.get('/api/monolith/public/pages/visitor-info');
                setVisitorInfo(responseData);
                visitorInfoRef.current = true;
            }
            catch (error) {
                console.error(error);
            }
        };
        getVisitorInfo();
    }, [setVisitorInfo]);
    return children;
}
